import { bsc, bscTestnet, mainnet, sepolia, SupportedChainId } from '@packet/constants/AppSupportChains';
import { Hash } from 'viem';

export const ChainConfigMap: Record<SupportedChainId, { appContract: Hash; freezeApiUrl: string; relayerApiUrl: string }> = {
  [sepolia.id]: {
    appContract: import.meta.env.VITE_SEPOLIA_APP_CONTRACT as Hash,
    freezeApiUrl: import.meta.env.VITE_SEPOLIA_API_FREEZE_URL,
    relayerApiUrl: import.meta.env.VITE_SEPOLIA_API_RELAYER_URL,
  },
  [bscTestnet.id]: {
    appContract: import.meta.env.VITE_BSCTEST_APP_CONTRACT as Hash,
    freezeApiUrl: import.meta.env.VITE_BSCTEST_API_FREEZE_URL,
    relayerApiUrl: import.meta.env.VITE_BSCTEST_API_RELAYER_URL,
  },
  [mainnet.id]: {
    appContract: import.meta.env.VITE_MAINNET_APP_CONTRACT as Hash,
    freezeApiUrl: import.meta.env.VITE_MAINNET_API_FREEZE_URL,
    relayerApiUrl: import.meta.env.VITE_MAINNET_API_RELAYER_URL,
  },
  [bsc.id]: {
    appContract: import.meta.env.VITE_BSC_APP_CONTRACT as Hash,
    freezeApiUrl: import.meta.env.VITE_BSC_API_FREEZE_URL,
    relayerApiUrl: import.meta.env.VITE_BSC_API_RELAYER_URL,
  },
};
